import { useEffect, useState } from "react";
import { Buildings, ShieldCheck } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { PERMISSIONS } from "../lib/permissions";
import DatosOrganizacion from "../components/configuracion/DatosOrganizacion";
import DatosLegales from "../components/configuracion/DatosLegales";

export default function Configuracion() {
  const { can } = useAuth();

  const canManageOrganization = can(PERMISSIONS.MANAGE_ORGANIZATION_CONFIG);
  const canManageLegal = can(PERMISSIONS.MANAGE_SETTINGS);

  const [activeTab, setActiveTab] = useState(
    canManageOrganization ? "organizacion" : "legal",
  );

  useEffect(() => {
    if (activeTab === "organizacion" && !canManageOrganization) {
      setActiveTab("legal");
    }

    if (activeTab === "legal" && !canManageLegal) {
      setActiveTab("organizacion");
    }
  }, [activeTab, canManageOrganization, canManageLegal]);

  if (!canManageOrganization && !canManageLegal) {
    return (
      <div className="p-6 md:p-8">
        <h1 className="font-display text-2xl font-bold text-med-text">
          Configuración
        </h1>
        <p className="mt-3 text-med-muted">
          No tienes permisos para acceder a la configuración.
        </p>
      </div>
    );
  }

  const tabs = [
    {
      id: "organizacion",
      label: "Datos de la organización",
      icon: Buildings,
      visible: canManageOrganization,
    },
    {
      id: "legal",
      label: "Datos legales y privacidad",
      icon: ShieldCheck,
      visible: canManageLegal,
    },
  ].filter((tab) => tab.visible);

  return (
    <div className="p-6 md:p-8 space-y-6" data-testid="configuracion-page">
      <div>
        <h1 className="font-display text-2xl font-bold text-med-text">
          Configuración
        </h1>
        <p className="mt-1 text-med-muted">
          Gestiona los datos de tu organización y su información legal.
        </p>
      </div>

      <div className="flex flex-wrap gap-2 border-b border-med-border">
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => setActiveTab(id)}
            className={`inline-flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
              activeTab === id
                ? "border-med-primary text-med-primary"
                : "border-transparent text-med-muted hover:text-med-text"
            }`}
          >
            <Icon size={19} weight="duotone" />
            {label}
          </button>
        ))}
      </div>

      {activeTab === "organizacion" && canManageOrganization && (
        <DatosOrganizacion />
      )}

      {activeTab === "legal" && canManageLegal && <DatosLegales />}
    </div>
  );
}
